// Renderer.ts
import * as THREE from 'three';
import { logDebug } from '../../utils/logger';

export default function setupRenderer(container: HTMLElement | null = null): THREE.WebGLRenderer {
  logDebug('Renderer: Setting up renderer with container:', container);

  const renderer = new THREE.WebGLRenderer({ antialias: true });
  (renderer as any).toneMapping = THREE.ACESFilmicToneMapping;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  // Enable local clipping for shield material compatibility
  (renderer as any).localClippingEnabled = true;

  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);

  logDebug('Renderer: Canvas element created:', renderer.domElement);
  logDebug('Renderer: Canvas dimensions:', renderer.domElement.width, 'x', renderer.domElement.height);

  if (container) {
    container.appendChild(renderer.domElement);
    logDebug('Renderer: Canvas appended to container');
    logDebug('Renderer: Container children count:', container.children.length);
  } else {
    const sceneContainer = document.getElementById('sceneContainer');
    if (sceneContainer) {
      sceneContainer.appendChild(renderer.domElement);
      logDebug('Renderer: Canvas appended to sceneContainer');
    } else {
      console.error('Renderer: No container or sceneContainer found');
    }
  }

  return renderer;
}
